import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloMedia extends AloBase {          
    slgId:number
    mdaCopyright:string
    mdaExt:string
    slug:string
}

export const getDefaultAloMedia = ():AloMedia => {
    return {  
        ...getDefaultAloBase(),
        id:1,
        slgId:1,
        mdaCopyright:"",
        mdaExt:".png",
        slug:"no-image"
    }
}

export const cleanAloMedia = (media:AloMedia) => {
    if(!media) return    
    if(!media.id) delete media.id
}